import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#f0f0f0",
    },
    primary: {
      main: "#009cf8",
      contrastText: "#fdfdfd",
    },
    primaryInverted: {
      main: "#fdfdfd",
      contrastText: "#009cf8",
    },
    neutral: {
      main: "#fdfdfd",
      contrastText: "#757575",
    },
    neutralInverted: {
      main: "#757575",
      contrastText: "#fdfdfd"
    },
    neutralDark: {
      main: "#e6e6e6",
      contrastText: "#7e8080",
    },
    muted: {
      main: "#95a2b4",
    },
    performantSignal: {
      main: "#07A89E",
      contrastText: "#fdfdfd"
    },
    presentSignal: {
      main: "#77C8C2",
      contrastText: "#fdfdfd"
    }
  },
  text: {
    primary: "#3d4849",
  },
  typography: {
    color: "#3d4849",
    fontFamily: "Open Sans",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    button: {
      textTransform: "none",
    },
  },
});

theme.components = {
  MuiTypography: {
    variants: [
      {
        props: { variant: "campaign-list-item" },
        style: {
          color: theme.text.primary,
          fontWeight: "bold",
          fontSize: "0.875em",
        },
      },
      {
        props: { variant: "title" },
        style: {
          color: theme.text.primary,
          fontWeight: "bold",
          fontSize: "1.25em",
          textTransform: "uppercase",
        },
      },
    ],
  },
  MuiListItem: {
    variants: [
      {
        props: { variant: "campaign-list-selected" },
        style: {
          padding: "12px",
          borderBottom: "1px solid #e0e0e0",
          background: "#d0f0ff",
          "&:hover": {
            background: "#C2EBFF",
          },
          boxShadow: `-6px 0 ${theme.palette.primary.main} inset`,
        },
      },
      {
        props: { variant: "campaign-list-inactive" },
        style: {
          padding: "12px",
          borderBottom: "1px solid #e0e0e0",
          background: "#eee",
          "&:hover": {
            background: "#e4e4e4",
          },
        },
      },
      {
        props: { variant: "campaign-list-item" },
        style: {
          padding: "12px",
          borderBottom: "1px solid #e0e0e0",
        },
      },
    ],
  },
  MuiIconButton: {
    variants: [
      {
        props: { variant: "no-hover" },
        style: {
          "&:hover": {
            backgroundColor: "transparent",
          },
          marginBottom: "4px",
        },
      },
    ],
  },
};

export default theme;
